import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
let template = require('./dv-home-icon.html');

export class DvHomeIconComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {};
    template = template;
    controller = DvHomeIconController;
    controllerAs = 'vm';
}

export class DvHomeIconController {

    TSRoleUtil: any;

    static $inject: any[] = ['$state'];

    constructor(private $state: IStateService) {
    }

    public goBackHome(): void {
        this.$state.go('gesuchstellerDashboard');
    }

}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-home-icon/dv-home-icon.ts